import Image, { ImageProps, StaticImageData } from "next/image";
import { FC, useState } from "react";
import placeholder from "@/Assets/Images/placeholder.png";

interface CustomImageProps extends Omit<ImageProps, "src" | "alt"> {
  src: string | StaticImageData;
  alt: string;
  className?: string;
  fallbackSrc?: string;
}

const Img: FC<CustomImageProps> = ({
  src,
  alt = "img",
  className = "",
  fallbackSrc = placeholder,
  ...props
}) => {
  const [imgSrc, setImgSrc] = useState(src);

  return (
    <Image
      src={imgSrc}
      alt={alt}
      className={className}
      onError={() => setImgSrc(fallbackSrc as any)}
      {...props}
    />
  );
};

export default Img;
